import { useSuspenseQuery } from '@apollo/client';

import type { SeoJobRoleSalary } from '@xing-com/crate-common-graphql-types';
import { SeoJobRoleSalaryDocument } from '@xing-com/crate-jobs-domain-serps-graphql';

import { useSerpsMatch } from './use-serps-match';

type UseSeoJobRoleSalary = {
  data: {
    rangeStart?: SeoJobRoleSalary['rangeStart'] | null;
    rangeEnd?: SeoJobRoleSalary['rangeEnd'] | null;
  };
  error?: Error | undefined;
};

export const useSeoJobRoleSalary = (): UseSeoJobRoleSalary => {
  const serpMatch = useSerpsMatch();
  const { data, error } = useSuspenseQuery(SeoJobRoleSalaryDocument, {
    variables: {
      jobRole: serpMatch?.categoryValue || '',
      serpType: 'jobRole',
    },
    errorPolicy: 'all',
  });

  return {
    data: {
      rangeStart: (data?.seoJobRoleSalary?.collection || [])[0]?.rangeStart,
      rangeEnd: (data?.seoJobRoleSalary?.collection || [])[0]?.rangeEnd,
    },
    error,
  };
};
